import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect, useSelector } from 'react-redux'
import noop from 'lodash/noop'
import { useNavigate } from 'react-router-dom'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import URL from '../../constants/urls'
import { globalKeyStore } from '../../redux/actions/globalState'
import EventCard from '../../components/global/EventCard'
import { convertParkingTime, getNearestMonth, isTimeBeforeCurrentFacilityTime } from '../../utils/helper'
import { useParams } from 'react-router-dom'
import moment from 'moment-timezone'

function BookingList({ dispatch, isMainScreen, rawEventsData, firstLoad, notify, selectedFacilityId }) {
    
    const user = window.location.toString().split('/')[3]
    const navigate = useNavigate()
    const { facility } = useParams()
    const [sliceEvent, setSliceEvent] = useState([])
    // const sliceEvent = eventData?.slice(0, noOfEventShow)
    const localFacilityId = JSON.parse(localStorage.getItem('selectedFacilityId'))
    const [facilityDet, setFacilityDet] = useState({
        name: null,
        defaultPrice: '0.00'
    })

    const eventData = useSelector((state) => state.globalReducers.allEventsData)


    const handleBookingButtton = (id = '', facilityID = '') => {
        if (user) {
            if (facility) {
                navigate(`/${user}/${URL?.BOOKING_DETAIL}${facilityID ? '/' + facilityID : localFacilityId ? '/' + localFacilityId : ''}${id ? '/' + id : ''}`)
            } else {
                navigate(`${URL?.BOOKING_DETAIL}${facilityID ? '/' + facilityID : localFacilityId ? '/' + localFacilityId : ''}${id ? '/' + id : ''}`)
            }
        } else {
            navigate('*')
        }
    }
    useEffect(() => {
        if (eventData?.length > 0 && eventData[0]?.facilities?.length) {
            let facilityName = eventData[0]?.facilities?.filter((item) => item?.id === localFacilityId)
            if (facilityName?.length > 0) {
                setFacilityDet({ ...facilityDet, defaultPrice: facilityName[0]?.base_event_rate, name: facilityName[0]?.full_name })
            }
        }
        if (rawEventsData && !isNaN(facility) && firstLoad?.current == 0) {
            const mmthNames = Object.keys(rawEventsData)
            const nearestMonth = getNearestMonth(mmthNames)
            setSliceEvent(rawEventsData[nearestMonth])
            let curMonth = moment().format('MMM-YYYY')
            if (curMonth != nearestMonth) {
                const firstDate = moment(nearestMonth, 'MMM-YYYY').endOf('month')
                dispatch(globalKeyStore({ selectedYearForLabel: moment(firstDate).format('YYYY-MM-DD') }))
            } else {
                dispatch(globalKeyStore({ selectedYearForLabel: moment(curMonth, 'MMM-YYYY').startOf('month').format('YYYY-MM-DD') }))
            }
        } else {
            setSliceEvent(eventData)
        }
    }, [rawEventsData, eventData])
    return (

        (eventData?.length > 0) ? sliceEvent?.map((item) => {
            // Always recalculate isBookingClosed on every render
            let currentFacilityID = selectedFacilityId ? selectedFacilityId : localStorage?.getItem('selectedFacilityId')

            // Find the facility from item.facilities matching currentFacilityID
            const matchedFacility = item?.facilities?.find(
                (f) => String(f.id) === String(currentFacilityID)
            )

            let facilityTimeZone = matchedFacility?.timezone ? matchedFacility?.timezone : 'America/New_York'
            let isBookingClosed = isTimeBeforeCurrentFacilityTime(item?.stop_event_booking_time, facilityTimeZone)

            let facilityName = matchedFacility?.[0]?.full_name
            return <EventCard
                key={item?.id}
                handleBookingButtton={handleBookingButtton}
                imageUrl={(item?.image_url) ? item?.image_url : 'NoImage'}
                title={item?.title}
                detials={item?.description}
                startDate={item?.start_time}
                time={convertParkingTime(item?.parking_start_time, item?.parking_end_time)}
                paybaleAmount={(item?.event_rate === '0.00' || item?.event_rate === 0) ? item?.facilities?.[0]?.base_event_rate : item?.event_rate}
                id={item?.id}
                isMainScreen={(isMainScreen) ? isMainScreen : false}
                facilitiesName={facilityDet.name ? facilityDet.name : facilityName}
                facilityPrice={facilityDet.defaultPrice}
                isBookingClosed={isBookingClosed}
                dispatch={dispatch}
                notify={notify}
                selectedEvent={item}
                currentFacilityID={currentFacilityID}
            />
        }) : <h4 className='w-100 text-primary py-3 text-center'>No events available.</h4>
    )
}

BookingList.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    globalData: PropTypes.object,
    eventData: PropTypes.array,
    noOfEventShow: PropTypes.number,
    isMainScreen: PropTypes.bool,
    rawEventsData: PropTypes.array,
    firstLoad: PropTypes.object,
    selectedFacilityId: PropTypes.string,
}

BookingList.defaulProps = {
    dispatch: noop,
    globalData: EMPTY_OBJECT,
    notify: noop,
    eventData: EMPTY_ARRAY,
    noOfEventShow: 4,
    isMainScreen: false,
    rawEventsData: EMPTY_ARRAY,
    firstLoad: {},
    selectedFacilityId: '',
}


function mapStateToProps({ globalReducers }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        eventData: globalReducers?.allEventsData,
        noOfEventShow: globalReducers?.noOfEventShow,
        rawEventsData: globalReducers?.rawEventsData,
    }
}

export default connect(mapStateToProps)(BookingList)